<ngb-toast [autohide]="false" class="bg-warning">
  <div class="toast-text" style="font-size: 1.5rem; padding: 0">
    <i class="material-icons">priority_high</i>
    {{ text }}
  </div>
</ngb-toast>
